import { Col } from "antd";
import { DetailStatisticCard } from "./DetailStatisticCard";
import { VideoIcon } from "@phosphor-icons/react";
import { useCustom, useTranslate } from "@refinedev/core";
import { useSearchParams } from "react-router-dom";
import { VideoSummaryStats } from "types/";
import { ANALYTICS_STALE_TIME, TARGETS } from "./constants/constants";
import { analyticsTheme } from "./analyticsTheme";
import { useAnalyticsBackState } from "../../projects/hooks/useAnalyticsBack";

const T_PREFIX =
  "media.projects.analytics.dashboard.summaryCards.videoExplainer";

interface VideoSummaryProps {
  projectId: string;
}

export const VideoSummary: React.FC<VideoSummaryProps> = ({ projectId }) => {
  const t = useTranslate();
  const [searchParams] = useSearchParams();
  const backState = useAnalyticsBackState();
  const {
    data: videoSummary,
    isLoading: isVideoSummaryLoading,
    isFetching: isVideoSummaryFetching,
  } = useCustom<VideoSummaryStats>({
    url: `analytics/projects/${projectId}/analytics/video/summary`,
    method: "get",
    queryOptions: {
      enabled: !!projectId,
      staleTime: ANALYTICS_STALE_TIME,
    },
    errorNotification: false,
  });

  const videoData = videoSummary?.data;

  return (
    <Col sm={24} md={8}>
      <DetailStatisticCard
        icon={<VideoIcon size={18} weight="fill" />}
        iconColor={analyticsTheme.datasetGreen}
        title={t(`${T_PREFIX}.title`).toUpperCase()}
        loading={isVideoSummaryLoading || isVideoSummaryFetching}
        metrics={[
          {
            title: t(`${T_PREFIX}.avgCompletion`).toUpperCase(),
            metric: videoData?.avg_completion_pct,
            type: "percentage",
            target: TARGETS.videoExplainer.avg_completion_pct,
            aim: "high",
          },
          {
            title: t(`${T_PREFIX}.playRate`).toUpperCase(),
            metric: videoData?.play_rate_pct,
            type: "percentage",
            target: TARGETS.videoExplainer.play_rate,
          },
          {
            title: t(`${T_PREFIX}.fullCompleters`).toUpperCase(),
            metric: videoData?.full_completers_pct,
            type: "percentage",
            target: TARGETS.videoExplainer.full_completers_pct,
            aim: "high",
          },
          {
            title: t(`${T_PREFIX}.chatRate`).toUpperCase(),
            metric: videoData?.chat_rate_pct,
            type: "percentage",
            target: TARGETS.videoExplainer.chat_rate_pct,
            aim: "high",
          },
        ]}
        to={`./video-explainer?${searchParams.toString()}`}
        replace
        state={backState}
        className={"video-explainer-card"}
      />
    </Col>
  );
};
